import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { Overlay } from "../../Overlay";
export const InitialsOverlay = styled(Overlay) `
  background: ${color.status.info.backgroundLight};
  display: flex;
  align-items: center;
  justify-content: center;

  &.green {
    background: ${color.brand.secondary.backgroundLight};
  }

  &.orange {
    background: ${color.status.warning.backgroundLight};
  }

  &.violet {
    background: ${color.brand.highlight.backgroundLight};
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5pdGlhbHNPdmVybGF5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvQXZhdGFyL3N0eWxlZC9Jbml0aWFsc092ZXJsYXkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLEtBQUssRUFBRSxNQUFNLGdEQUFnRCxDQUFDO0FBQ3ZFLE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sRUFBRSxPQUFPLEVBQUUsTUFBTSxlQUFlLENBQUM7QUFFeEMsTUFBTSxDQUFDLE1BQU0sZUFBZSxHQUFHLE1BQU0sQ0FBQyxPQUFPLENBQUMsQ0FBQTtnQkFDOUIsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsZUFBZTs7Ozs7O2tCQU0vQixLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxlQUFlOzs7O2tCQUlyQyxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBQyxlQUFlOzs7O2tCQUlwQyxLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxlQUFlOztDQUV0RCxDQUFDIn0=